/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AddAction/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function AddAction({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/AddAction"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let eventActionTypeValueData = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'type',
})
let constantData = 'wait'
let aggregateData = fromAggregate.equals(eventActionTypeValueData, constantData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}